// src/environments/environment.ts
import { Environment } from './environment.model';
export const environment: Environment = {
  production: false,
  stage: 'INT',
  region: 'EMEA',
  apiBaseUrls: {
    EMEA: 'https://onyhas30zh.execute-api.eu-west-1.amazonaws.com/fcl/v1'
  },
  cognitoConfigs: {
    EMEA: {
      aws_project_region: 'eu-west-1',
      aws_cognito_region: 'eu-west-1',
      aws_user_pools_id: 'eu-west-1_kNJ6SBVRX',
      aws_user_pools_web_client_id: '46kvhv882skhraav79n0mcqp9v',
      aws_cognito_identity_pool_id: 'eu-west-1:3790a099-7d3b-49dd-bfba-bf0ac3c0319f'
    }
  },
  zuoraEntity: ['EMEA', 'MAS_EMEA', 'IAP', 'MAS_IAP']
};